export default "__VITE_ASSET__BaIqDw4L__"